export default __webpack_public_path__ + "static/media/guide3.603d98df.svg";